import { Box, Grid2 as Grid, Theme } from '@mui/material';
import { useDispatch } from 'react-redux';

import { playerActions } from '@/store';
import { CPACanadaEpisode } from '@/types';

import {
  ChapterInfo,
  MediaControls,
  ProgressBar,
  ProgressInfo,
  VolumeSlider,
} from './components';

interface MiniPlayerProps {
  cpaCanadaContent: CPACanadaEpisode;
}

export const MiniPlayer = ({ cpaCanadaContent }: MiniPlayerProps) => {
  const dispatch = useDispatch();
  const { episode, chapter } = cpaCanadaContent;

  const setSeekPosition = ({ position }: { position: number }) => {
    dispatch(playerActions.setSeekToPosition(position));
  };

  return (
    <Box sx={styles.miniPlayerContainer}>
      <Box sx={styles.progressBarContainer}>
        <ProgressBar chapter={chapter} setSeekPosition={setSeekPosition} />
      </Box>
      <Grid container alignItems="center" sx={{ width: '100%' }}>
        <Grid size={{ xs: 3, md: 4 }}>
          <ChapterInfo episode={episode} chapter={chapter} />
        </Grid>
        <Grid size={{ xs: 4, sm: 5, md: 6, lg: 4 }}>
          <MediaControls chapter={chapter} setSeekPosition={setSeekPosition} />
        </Grid>
        <Grid size={{ xs: 5, sm: 4, md: 2, lg: 4 }}>
          <Box sx={styles.playerRight}>
            <ProgressInfo chapter={chapter} />
            <Box sx={styles.volumeControls}>
              <VolumeSlider />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

const styles = {
  miniPlayerContainer: (theme: Theme) => ({
    position: 'relative',
    backgroundColor: 'primary.main',
    boxShadow: '0 -5px 20px 0 rgba(0,0,0,0.5)',
    color: 'white',
    height: 90,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      height: 66,
    },
  }),
  progressBarContainer: (theme: Theme) => ({
    position: 'absolute',
    bottom: 71,
    left: 90,
    width: 'calc(100% - 90px)',
    [theme.breakpoints.down('sm')]: {
      left: 66,
      bottom: 32,
      width: 'calc(100% - 66px)',
      transform: 'translateY(calc(-50% + 2px))',
    },
  }),
  playerRight: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    justifyContent: 'flex-end',
  },
  volumeControls: {
    mr: 2.5,
    display: { xs: 'none', lg: 'block' },
  },
  expandButton: (theme: Theme) => ({
    height: 50,
    minHeight: 32,
    minWidth: 32,
    p: 0,
    width: 50,
    [theme.breakpoints.down('sm')]: {
      height: 44,
      width: 44,
    },
  }),
};
